
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

interface AnalysisErrorProps {
  error: string;
  onRetry: () => void;
}

export const AnalysisError = ({ error, onRetry }: AnalysisErrorProps) => {
  return (
    <Alert variant="destructive" className="mb-4 bg-red-50/80 border-red-200 text-red-800 shadow-sm rounded-lg">
      <AlertCircle className="h-4 w-4 text-red-500" />
      <AlertDescription className="flex items-center justify-between">
        <span>{error}</span>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={onRetry}
          className="ml-2 border-red-200 text-red-700 hover:bg-red-100/50 hover:text-red-800 shadow-sm transition-all duration-200 rounded-md"
        >
          Retry
        </Button>
      </AlertDescription>
    </Alert>
  );
};
